module.exports = __webpack_public_path__ + "img/curva.3ed6d793.svg";